import axios from "axios"
import { result } from "lodash";
import { BASE_AUTH_URL,ACCESS_TOKEN_KEY } from "../lib/constant"

export const userLogIn = async (userInfo, url) => {
    try {
        const result = await axios.post(`${BASE_AUTH_URL}/${url}`, userInfo);
        // if(result.data){
        //     localStorage.setItem(ACCESS_TOKEN_KEY, result.data.jwtToken)
        // }
        return result
    } 
    catch (err) {
        return { status: err?.response?.status }
    }
}

export const isUserLogedIn_ = async (userInfo, url) => {
    try {
        const token=localStorage.getItem(ACCESS_TOKEN_KEY);
        return token && token!=null;
    } 
    catch (err) {
        return { status: err?.response?.status }
    }
}

export const userRegistration = async (userData, url) => {
    try {
        return await axios.post(`${BASE_AUTH_URL}/${url}`, userData)
        .then(result=>{
            return result;
        })
        .catch(e=>{
            return e.response?.data;
        })
    }
    catch (error) {
        // console.log(error)
    }
}
export const commonGet = async (userData, url, direct=false) => {
    try {
        if(direct){
            const result = await axios.get(`${url}`)
            return result;
        }else{
            const result = await axios.get(`${BASE_AUTH_URL}/${url}`);
            return result;
        }
    }
    catch (error) {
        // console.log(error)
    }
}
export const commonPost = async (userData, url, direct=false) => {
    try {
        if(direct){
            const result = await axios.post(`${url}`, userData)
            return result;
        }
        else if(userData==false){
            const result = await axios.post(`${BASE_AUTH_URL}/${url}`)
            return result;
        }
        else{
            const result = await axios.post(`${BASE_AUTH_URL}/${url}`, userData)
            return result;
        }
    }
    catch (error) {
        // console.log(error)
    }
}

export const commonPostwithAuth = async (userData, url) => {
    try {
        userData.token=localStorage.getItem(ACCESS_TOKEN_KEY);
        const result = await axios.post(`${BASE_AUTH_URL}/${url}`, userData)
        return result;
    }
    catch (error) {
        // console.log(error)
    }
}